import { Component, OnInit } from '@angular/core';
import { BaseFormComponent } from '../../../../shared/base/base-form.component';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseService } from '../../../../shared/base/base.service';
import { Constants } from '../../../../../app/app.constants';
import { GiftPackage, GiftPackageItem } from '../gift-package.models';
import { ProductsService } from '../../products/products.service';
import { OptionsSource } from 'src/app/core/core.models';
import { AuthService } from 'src/app/core/auth.service';
import { LoadingService } from 'src/app/core/loading.service';
import { TranslatorService } from 'src/app/core/translator.service';
import { UtilityService } from 'src/app/core/utility.service';
import { DialogService } from 'src/app/core/dialog.service';
import { AlertService } from 'src/app/core/alert.service';


@Component({
  selector: 'app-gift-package-form',
  templateUrl: './gift-package-form.component.html',
  styleUrls: ['./gift-package-form.component.scss']
})
export class GiftPackageFormComponent extends BaseFormComponent implements OnInit {
  public productsSource: OptionsSource;
  public tabs: string[] = ['PRODUCTS', 'IMAGES'];
  public giftPackageItems: GiftPackageItem[] = [];

  constructor(
    public authService: AuthService,
    public loadingService: LoadingService,
    public translatorService: TranslatorService,
    public utilityService: UtilityService,
    protected activatedRoute: ActivatedRoute,
    protected baseService: BaseService,
    protected dialogService: DialogService,
    protected router: Router,
    protected alertService: AlertService,
    protected productsService: ProductsService
  ) {
    super(authService, loadingService, translatorService, utilityService, activatedRoute, baseService, dialogService, router, alertService);
  }

  ngOnInit(): void {
    this.authorities.init('CD_CD', 'R_CD', 'U_CD', 'CD_CD');

    this.url = `${Constants.contextPath}/gift-packages`;
    this.prepareLookupData();
    this.prepareFormData(new GiftPackage(), (response: GiftPackage) => {
      response.breadcrumbsId = response.name;
      return this.modifyResponse(response);
    });
  }

  private prepareLookupData() {
    this.productsSource = this.productsService.getProductsOptions();
  }

  public modifyResponse(response: GiftPackage) {
    if(response.giftPackageItems){
      this.giftPackageItems = response.giftPackageItems;
    }
    
    return response;
  }

  public displayProduct = (event) => {
    return event.product ? event.product.name : '';
  }

  private modifyGiftPackageItems(giftPackageItems) {
    let modifiedItems = [];

    for(let item of giftPackageItems){
      let modifiedItem = item;
      modifiedItem.product = item.product.id;
      modifiedItems.push(modifiedItem)
    }

    return modifiedItems;
  }

  public saveChanges(): void {
    if (!this.isFormValid())
      return;

    this.formData.giftPackageItems = this.modifyGiftPackageItems(this.giftPackageItems);

    if (this.id == null)
      this.baseService.create(this.url, this.formData, () => {
        this.onSaveSuccess();
      });
    else
      this.baseService.update(this.url, this.formData, () => {
        this.onSaveSuccess();
      });
  }

  public uploadFinishedEvent(event) {
    if(event && event.path)
      this.formData.image = event.path;
  }
  
  public deletedEvent(event) {
    if(event == this.formData.image) {
      this.formData.image = null;
      this.saveChanges();
    }
  }

  isFileUploadDisabled(): boolean {
    return  this.giftPackageItems?.length == 0 || this.formData.code == null || this.formData.name == null || this.formData.description == null ||
            this.formData.code == '' || this.formData.description == '' || this.formData.name == '';
  }
}
 